import script from "./ProductSaleVariantTableSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSaleVariantTableSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductSaleVariantTableSkeleton.vue?vue&type=style&index=0&id=fda62db8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fda62db8"]])

export default __exports__